import { localDateFromDate } from "@flockcover/flock-svc-core-types"
import * as DateFns from "date-fns"
import { BaseFleetEntry } from "../../../../api/fleet"

const NUMBER_OF_ROWS = 5

const makeEmptyRow = (date?: Date) => {
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions()
  return {
    registrationNumber: ``,
    onCoverDate: localDateFromDate(date || new Date(), timeZone),
    offCoverDate: null,
  }
}

export const getInitalRows = (initialValue?: ReadonlyArray<BaseFleetEntry>, date?: Date) => {
  if (initialValue && (initialValue.length || 0) >= NUMBER_OF_ROWS) return initialValue
  const rows = []
  for (let i = 0; i < NUMBER_OF_ROWS; i++) {
    rows.push(initialValue?.[i] || makeEmptyRow(date))
  }
  return rows
}

export const formatCoverDate = (date?: Date) => (date ? DateFns.format(date, `yyyy-MM-dd`) : undefined)
